import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/logo.png';

export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const campers = [
    { name: "Camper Lagos", slug: "lagos" },
    { name: "Camper Area d'Bon", slug: "area-bon" },
    { name: "Camper Area Brava", slug: "area-brava" },
    { name: "Camper Melide", slug: "melide" }
  ];

  const menuItems = [
    { name: "Inicio", href: "/" },
    { 
      name: "Nuestras campers", 
      href: "/campers",
      hasSubmenu: true,
      submenu: campers.map(camper => ({
        name: camper.name,
        href: `/campers/${camper.slug}`
      }))
    },
    { name: "Condiciones alquiler", href: "/condiciones-alquiler" },
    { name: "Regala Furgos Río", href: "/regala" },
    { name: "Blog", href: "/blog" }
  ];

  useEffect(() => {
    // Check if there's a hash in the URL when landing on the homepage
    if (location.pathname === '/' && location.hash === '#contacto') {
      // Small delay to ensure the content is rendered
      setTimeout(() => {
        document.getElementById('contacto')?.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    }
  }, [location]);

  const handleContactClick = (e) => {
    if (window.location.pathname === '/') {
      e.preventDefault();
      document.getElementById('contacto')?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      <header className="fixed top-0 left-0 right-0 bg-white shadow-sm z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex items-center justify-between h-16">
            <div className="flex items-center">
              <Link to="/" className="flex-shrink-0">
                <img className="h-8 w-auto" src={logo} alt="Furgos Río" />
              </Link>

              {/* Desktop menu */}
              <nav className="hidden md:ml-10 md:flex md:items-center md:space-x-8">
                {menuItems.map((item) => (
                  <div key={item.name} className="relative">
                    {item.hasSubmenu ? (
                      <div
                        className="relative group"
                      >
                        <Link
                          to={item.href}
                          className="text-gray-700 hover:text-gray-900 px-3 py-2 rounded-md text-sm font-medium inline-flex items-center"
                        >
                          {item.name}
                          <svg className="ml-1 h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                          </svg>
                        </Link>
                        
                        <div className="absolute left-0 invisible group-hover:visible opacity-0 group-hover:opacity-100 transition-all duration-300 pt-2">
                          <div className="w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5">
                            <div className="py-1" role="menu">
                              {item.submenu.map((subItem) => (
                                <Link
                                  key={subItem.name}
                                  to={subItem.href}
                                  className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                                  role="menuitem"
                                >
                                  {subItem.name}
                                </Link>
                              ))}
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      <Link
                        to={item.href}
                        onClick={item.name === "Contacto" ? handleContactClick : undefined}
                        className="text-gray-700 hover:text-gray-900 px-3 py-2 rounded-md text-sm font-medium"
                      >
                        {item.name}
                      </Link>
                    )}
                  </div>
                ))}
                
                {/* Desktop WhatsApp Button */}
                <a
                  href="https://wa.me/34648728151"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 bg-brand hover:bg-brand/90 text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors duration-300"
                >
                  <svg 
                    className="w-4 h-4" 
                    fill="currentColor" 
                    viewBox="0 0 24 24"
                  >
                    <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946.003-6.556 5.338-11.891 11.893-11.891 3.181.001 6.167 1.24 8.413 3.488 2.245 2.248 3.481 5.236 3.48 8.414-.003 6.557-5.338 11.892-11.893 11.892-1.99-.001-3.951-.5-5.688-1.448l-6.305 1.654zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592 5.448 0 9.886-4.434 9.889-9.885.002-5.462-4.415-9.89-9.881-9.892-5.452 0-9.887 4.434-9.889 9.884-.001 2.225.651 3.891 1.746 5.634l-.999 3.648 3.742-.981zm11.387-5.464c-.074-.124-.272-.198-.57-.347-.297-.149-1.758-.868-2.031-.967-.272-.099-.47-.149-.669.149-.198.297-.768.967-.941 1.165-.173.198-.347.223-.644.074-.297-.149-1.255-.462-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.151-.172.2-.296.3-.495.099-.198.05-.372-.025-.521-.075-.148-.669-1.611-.916-2.206-.242-.579-.487-.501-.669-.51l-.57-.01c-.198 0-.52.074-.792.372s-1.04 1.016-1.04 2.479 1.065 2.876 1.213 3.074c.149.198 2.095 3.2 5.076 4.487.709.306 1.263.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.695.248-1.29.173-1.414z"/>
                  </svg>
                  Chatea con nosotros
                </a>
              </nav>
            </div>

            {/* Mobile menu button */}
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              className="md:hidden inline-flex items-center justify-center p-2 rounded-md text-gray-700 hover:text-gray-900 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-brand"
            >
              <span className="sr-only">Open main menu</span>
              {!isMenuOpen ? (
                <svg className="block h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                </svg>
              ) : (
                <svg className="block h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              )}
            </button>
          </div>
        </div>

        {/* Mobile menu */}
        {isMenuOpen && (
          <div className="md:hidden">
            <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3">
              {menuItems.map((item) => (
                <div key={item.name}>
                  <Link
                    to={item.href}
                    onClick={(e) => {
                      setIsMenuOpen(false);
                      if (item.name === "Contacto") handleContactClick(e);
                    }}
                    className="block px-3 py-2 rounded-md text-base font-medium text-gray-700 hover:text-gray-900 hover:bg-gray-100"
                  >
                    {item.name}
                  </Link>
                  {item.hasSubmenu && (
                    <div className="pl-4">
                      {item.submenu.map((subItem) => (
                        <Link
                          key={subItem.name}
                          to={subItem.href}
                          onClick={() => setIsMenuOpen(false)}
                          className="block px-3 py-2 text-sm text-gray-600 hover:text-gray-900 hover:bg-gray-50"
                        >
                          {subItem.name}
                        </Link>
                      ))}
                    </div>
                  )}
                </div>
              ))}
              
              {/* Mobile WhatsApp Button */}
              <a
                href="https://wa.me/34648728151"
                target="_blank"
                rel="noopener noreferrer"
                className="block w-full text-center bg-brand hover:bg-brand/90 text-white px-3 py-2 rounded-lg text-base font-medium transition-colors duration-300 mt-2"
              >
                Chatea con nosotros
              </a>
            </div>
          </div>
        )}
      </header>
      {/* Spacer div to prevent content from hiding under fixed header */}
      <div className="h-16"></div>
    </>
  );
}
